/**
 * Whether a sidebar menu path points at `currentPath` (`pathname + search`).
 *
 * Exact match first. Otherwise a menu path that carries no `projectId` still matches the same
 * page when the URL has one: the ticket page adds `?projectId=` to its URL by default, but the
 * menu entry for the main project (and client entries) are stored without it.
 */
const matchesMenuPath = (menuPath, currentPath) => {
  if (!menuPath || !currentPath) return false;
  if (menuPath === currentPath) return true;
  if (menuPath.includes('projectId=')) return false;

  const [pathname, search = ''] = currentPath.split('?');
  const params = new URLSearchParams(search);
  if (!params.has('projectId')) return false;
  params.delete('projectId');
  const rest = params.toString();
  return menuPath === (rest ? `${pathname}?${rest}` : pathname);
};

export default matchesMenuPath;
